<template lang="pug">
  .b-crm-lead-detail-comment-form
    ._attachments(v-if="items.length")
      FileList(:files="items" @remove="removeFile")
    ._row
      CrmFileUploadButton._btn(
        ref="upload"
        :files="attachments"
        :disabled="sending"
        @change="attachments = $event"
        @uploadingChange="uploading = $event"
        )
      textarea._input(
        ref="input"
        v-model="text"
        rows="1"
        placeholder="Написать сообщение..."
        :disabled="sending"
        @input="resizeInput"
        @keydown.enter.exact.prevent="submit"
      )
      button._btn(type="button" title="Отправить" :disabled="!canSend" @click="submit")
        Icon(name="send" pointer colored)
</template>

<script>
import FileList from '@/components/FileList.vue';
import CrmFileUploadButton from '@/components/crm/CrmFileUploadButton.vue';

export default {
  name: 'CrmLeadDetailCommentForm',
  components: { FileList, CrmFileUploadButton },
  props: {
    // идёт отправка комментария — форма блокируется на это время
    sending: Boolean,
  },
  data() {
    return {
      text: '',
      // загруженные файлы: объекты ответа сервера, у каждого есть @id
      attachments: [],
      // те, что ещё летят; ими управляет CrmFileUploadButton (uploading.sync)
      uploading: [],
    };
  },
  computed: {
    /** Обе половины вложений в одном списке для FileList. */
    items() {
      return [
        ...this.attachments.map(file => ({ id: file.id, file, removable: !this.sending })),
        ...this.uploading,
      ];
    },
    canSend() {
      if (this.sending) return false;
      // пока файл ещё грузится, отправлять рано: у него нет IRI
      if (this.uploading.length) return false;

      return !!this.text.trim() || this.attachments.length > 0;
    },
  },
  methods: {
    // растит textarea под содержимое: сначала auto, чтобы поле умело и
    // уменьшаться обратно, а не только расти
    resizeInput() {
      const el = this.$refs.input;
      el.style.height = 'auto';
      el.style.height = `${el.scrollHeight}px`;
    },

    removeFile(item) {
      this.$refs.upload.removeItem(item);
    },

    submit() {
      if (!this.canSend) return;

      this.$emit('submit', {
        text: this.text.trim(),
        files: this.attachments.map(file => file['@id']).filter(Boolean),
      });
    },

    /** Вызывает родитель после успешной отправки. */
    reset() {
      this.text = '';
      this.attachments = [];
      this.$nextTick(this.resizeInput);
    },
  },
};
</script>

<style scoped lang="scss">
.crm-lead-detail-comment-form {
  // светлее --color-super-light (он используется в панели у CrmLeadDetailComment)
  // — совпадает с фоном самого попапа
  background: var(--main-bg);
  border-radius: 6px;
  padding: 8px 12px;

  &__attachments {
    // выходит за собственные боковые отступы формы, чтобы скроллбар и
    // граница шли во всю ширину; такой же padding возвращает сами тайлы
    // на место
    margin: 0 -12px 8px;
    padding: 0 12px 8px;
    border-bottom: 1px solid var(--color-purple);
  }

  &__row {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__btn {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    color: var(--color-light-dark);

    &[disabled],
    &.disabled {
      opacity: 0.4;
      cursor: default;

      // Icon с pointer ставит cursor: pointer инлайном — перебиваем его
      // на выключенной кнопке, отдавая курсор самой кнопке
      ::v-deep * {
        pointer-events: none;
      }
    }
  }

  &__input {
    flex-grow: 1;
    min-width: 0;
    box-sizing: border-box;
    // без min-height: line-height сам даёт естественную высоту в одну строку,
    // ровно под align-items: center у __row. Растёт с содержимым до этого
    // предела (см. resizeInput), дальше скроллится внутри
    max-height: 120px;
    padding: 0;
    border: none;
    border-radius: 6px;
    background: none;
    font: inherit;
    font-size: 12px;
    line-height: 1.4;
    color: var(--color-dark-gray);
    outline: none;
    resize: none;
    overflow-y: auto;

    &::placeholder {
      color: var(--color-middle-gray);
    }
  }
}
</style>
